import { Link } from "react-router"
import { ArrowUpRight } from "../layout"
import { Eyebrow } from "../components"

export function AbilityPrograms() {
  return (
    <section className="bg-cream-50 py-10 lg:py-[60px]">
      <div className="public-container">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-16">
          <div className="flex max-w-xl flex-col items-start gap-6 lg:max-w-[557px]">
            <Eyebrow dot>Ability Program</Eyebrow>
            <h2 className="font-display text-[32px] font-bold leading-tight text-ink sm:text-[48px] sm:leading-none">
              Ability Program.{" "}
              <span className="text-forest-700">Opportunity for all</span>
            </h2>
            <p className="text-lg leading-relaxed text-ink">
              We also support people living with physical disabilities across every age: children, teens, and university students. Mobility aids, hearing devices, visual support, therapy, school fees, and adapted skills training — so ability is never limited by access.
            </p>
            <Link
              to="/ability-program"
              className="inline-flex items-center gap-3 rounded-full bg-forest-950 py-1.5 pl-5 pr-1.5 text-base font-semibold text-white transition-colors hover:bg-forest-800"
            >
              Explore the Ability Program
              <span className="grid h-10 w-10 place-items-center rounded-full bg-white text-forest-950">
                <ArrowUpRight />
              </span>
            </Link>
          </div>
          <div className="relative h-[280px] w-full overflow-hidden rounded-[20px] lg:h-[499px] lg:w-[719px] lg:max-w-[719px] lg:rounded-[30px]">
            <img
              src="/images/pages/about-ability.jpg"
              alt="Children supported by the Ability Program"
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  )
}
